import { AxiosInstance } from 'axios';
import { CachedItem } from '@DStvMonoRepo/self-service-core';
import { environment } from '@environment';
import { AuthUtils } from 'core/stores/auth/auth-utils';
import { SiteConfigStore } from 'core/stores/site-config.store';
import { CEFAuthenticateDomains, FreshDeskAuthenticateDomains } from './external-api-domains';

enum RequestType {
  None,
  CEF,
  DSO,
  FD
}

const getRequestType = (url?: string) => {
  if (!url) {
    return RequestType.None;
  }

  if (FreshDeskAuthenticateDomains.find((domain) => url.startsWith(domain))) {
    return RequestType.FD;
  }

  if (CEFAuthenticateDomains.find((domain) => url.startsWith(domain))) {
    return RequestType.CEF;
  }

  return RequestType.None;
}

export const GetAuthenticationToken = (url?: string) => {
  const type = getRequestType(url);

  switch (type) {
    case RequestType.CEF:
      const token = AuthUtils.GetStoredToken();
      return { token, type };

    default:
      return { token: null, type };
  }
};

export const AuthInterceptor = (axiosInstance: AxiosInstance) => {
  axiosInstance.interceptors.request.use(
    (config) => {
      const { token, type } = GetAuthenticationToken(config.url);
      const cachedCountry = new CachedItem('country', true);

      config.headers['Content-Type'] = `application/json`;

      if (type === RequestType.CEF) {
        config.headers['Authorization'] = `Bearer ${AuthUtils.GetStoredToken()}`;
        config.headers['provider'] = `${AuthUtils.GetStoredAuthProvider() || environment.DEFAULT_AUTH_PROVIDER}`;
        config.headers['x-businessunit'] = SiteConfigStore.businessUnit();
        config.headers['x-country-iso'] = `${cachedCountry.get()}`;
        config.headers['x-profile'] = `${environment.PAYMENT_PROFILE}`;
      }

      if (type === RequestType.FD) {
        config.headers['Authorization'] = window.btoa(`${environment.FRESHDESK_AUTH}`);
      }

      return config;
    }
  );
};